import { NavLink, Outlet, useNavigate, Link } from "react-router-dom";
import { LayoutDashboard, Inbox, Users, MessageSquare, LogOut, ExternalLink, ShieldCheck } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const nav = [
  { to: "/admin", end: true, icon: LayoutDashboard, label: "Dashboard", testid: "admin-nav-dashboard" },
  { to: "/admin/richieste", icon: Inbox, label: "Richieste", testid: "admin-nav-richieste" },
  { to: "/admin/clienti", icon: Users, label: "Clienti", testid: "admin-nav-clienti" },
  { to: "/admin/messaggi", icon: MessageSquare, label: "Messaggi", testid: "admin-nav-messaggi" },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const handleLogout = () => { logout(); navigate("/"); };

  return (
    <div className="flex min-h-screen bg-[#F8FAFC]">
      <aside className="hidden w-64 flex-col border-r border-slate-200 bg-[#0A192F] lg:flex">
        <div className="flex items-center gap-2 border-b border-white/10 px-6 py-5">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-[#10B981]">
            <ShieldCheck className="h-5 w-5 text-white" strokeWidth={2.4} />
          </span>
          <div>
            <p className="font-display text-sm font-extrabold text-white">ViviTranquillo</p>
            <p className="text-xs text-slate-400">Back Office</p>
          </div>
        </div>
        <nav className="flex-1 space-y-1 p-4">
          {nav.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} data-testid={n.testid}
              className={({ isActive }) =>
                `flex items-center gap-3 rounded-xl px-4 py-2.5 text-sm font-semibold transition-colors ${
                  isActive ? "bg-[#10B981] text-white" : "text-slate-300 hover:bg-white/5"
                }`}>
              <n.icon className="h-5 w-5" /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="space-y-1 border-t border-white/10 p-4">
          <Link to="/area" data-testid="admin-to-area" className="flex items-center gap-3 rounded-xl px-4 py-2.5 text-sm font-semibold text-slate-300 transition-colors hover:bg-white/5">
            <ExternalLink className="h-5 w-5" /> Area Clienti
          </Link>
          <button data-testid="admin-logout" onClick={handleLogout} className="flex w-full items-center gap-3 rounded-xl px-4 py-2.5 text-sm font-semibold text-slate-300 transition-colors hover:bg-white/5">
            <LogOut className="h-5 w-5" /> Esci
          </button>
        </div>
      </aside>

      <div className="flex flex-1 flex-col">
        <header className="sticky top-0 z-40 flex items-center justify-between border-b border-slate-200 bg-white px-6 py-4">
          <div className="flex items-center gap-2 lg:hidden">
            <ShieldCheck className="h-5 w-5 text-[#10B981]" />
            <span className="font-display text-sm font-bold text-[#0A192F]">Back Office</span>
          </div>
          <div className="ml-auto flex items-center gap-3">
            <span className="rounded-full bg-[#0A192F] px-3 py-1 text-xs font-bold text-white">STAFF</span>
            <div className="text-right">
              <p className="text-sm font-semibold text-[#0A192F]" data-testid="admin-user-name">{user?.name}</p>
              <p className="text-xs text-slate-500">{user?.email}</p>
            </div>
          </div>
        </header>
        <main className="flex-1 px-6 py-8 pb-24 lg:px-10 lg:pb-8">
          <Outlet />
        </main>
      </div>

      <nav className="fixed bottom-0 left-0 right-0 z-40 flex items-center justify-around border-t border-slate-200 bg-white px-1 py-2 lg:hidden">
        {nav.map((n) => (
          <NavLink key={n.to} to={n.to} end={n.end} data-testid={`${n.testid}-mobile`}
            className={({ isActive }) => `flex flex-col items-center gap-0.5 px-2 py-1 text-[10px] font-semibold ${isActive ? "text-[#10B981]" : "text-slate-500"}`}>
            <n.icon className="h-5 w-5" /> {n.label}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
